import styled from 'styled-components';
import { IconProps } from './types';

const OFFSET = 147;
const DURATION = '2s';

const SpinnerStyle = styled.svg`
  animation: rotator ${DURATION} linear infinite;

  @keyframes rotator {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(270deg);
    }
  }

  circle {
    stroke-dasharray: ${OFFSET};
    stroke-dashoffset: 0;
    transform-origin: center;
    animation:
      spinnerDash ${DURATION} ease-in-out infinite,
      spinnerColors 8.8s ease-in-out infinite;
  }

  @keyframes spinnerColors {
    0% {
      stroke: currentColor;
    }
    25% {
      stroke: currentColor;
    }
    50% {
      stroke: currentColor;
    }
    75% {
      stroke: currentColor;
    }
    100% {
      stroke: currentColor;
    }
  }

  @keyframes spinnerDash {
    0% {
      stroke-dashoffset: ${OFFSET};
    }
    50% {
      stroke-dashoffset: ${OFFSET / 4};
      transform: rotate(135deg);
    }
    100% {
      stroke-dashoffset: ${OFFSET};
      transform: rotate(450deg);
    }
  }
`;

const Spinner = (props: Omit<IconProps, 'iconName'>) => (
  <SpinnerStyle
    viewBox="0 0 66 66"
    xmlns="http://www.w3.org/2000/svg"
    // I still left here the spread operator in order to
    // handle data-attributes etc.
    {...(props as { className?: string })}
  >
    <circle
      fill="none"
      strokeWidth="6"
      strokeLinecap="round"
      cx="33"
      cy="33"
      r="20"
    />
  </SpinnerStyle>
);

export { Spinner };
